import ls from 'local-storage'
window.LS = ls
export default ls
